import React from "react";
import FloatMenuList from "../../Costing/FloatMenuList";

export default function ScrollMenu(props) {
  let toggleData = props.toggleData;
  let moduleList = Object.keys(toggleData).filter((x) => toggleData[x])

  return (
    <div class="scroll-up pull-right scroll-hide">
      <div class="fab">
        <span class="fab-action-button">
          <a class="btn-floating btn-large green">
            <i class="fa fa-bars font-for-icon-big" />
          </a>
        </span>
        <ul class="fab-buttons">
          <FloatMenuList
            moduleList={moduleList}
            goToDiv={props.scrollToModule}
          />
        </ul>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/SampleRequest/ScrollMenu/index.js